import { Lightroom } from "./Lightroom";

import { fabric } from "fabric";

fabric.Image.filters.Miami = fabric.util.createClass(
  fabric.Image.filters.Lightroom,
  {
    name: "Miami",

    type: "Miami",

    initialize: function (options) {
      this.callSuper("initialize", options);

      this.blacks = -2
      this.whites = 64
      this.shadows = 50
      this.contrast = -1
      this.exposure = 0.1
      this.vibrance = 31
      this.grainSize = 60
      this.highlights = -55
      this.grainAmount = 100
      this.temperature = 54
      this.grainRoughness = 62
      this.aquaHueAdjustment = 70
      this.blueHueAdjustment = -1
      this.greenHueAdjustment = 100
      this.orangeHueAdjustment = 1
      this.aquaLuminanceAdjustment = 1
      this.blueLuminanceAdjustment = -6
      this.aquaSaturationAdjustment = 80
      this.blueSaturationAdjustment = 80
      this.greenLuminanceAdjustment = -14
      this.greenSaturationAdjustment = 70
      this.orangeLuminanceAdjustment = -37
      this.yellowLuminanceAdjustment = 1
      this.orangeSaturationAdjustment = 11
      this.yellowSaturationAdjustment = -35
      this.tint = 24
      this.saturation = 17
      this.redHueAdjustment = 2
      this.redSaturationAdjustment = 22
      this.redLuminanceAdjustment = 2
      this.purpleHueAdjustment = 1
      this.purpleSaturationAdjustment = 2
      this.purpleLuminanceAdjustment = -1
      this.magentaHueAdjustment = 2
      this.yellowHueAdjustment = -75
      this.magentaSaturationAdjustment = 1
    },
  }
);

fabric.Image.filters.Miami.fromObject =
  fabric.Image.filters.Lightroom.fromObject;

const Miami = fabric.Image.filters.Miami;

export { Miami };
